import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsDispositionMethodList } from '../../data-provider/select-options/disposition-method-list';

export const useGetDispositionMethodList = () => {
  return useQuery({
    queryKey: ['pre-claims-disposition-method-list'],
    queryFn: () => fetchPreClaimsDispositionMethodList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
